import * as React from 'react';
import { ILoadPurchaseOrderDialogProps } from './LoadPurchaseOrderDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import LoadPurchaseOrderForm from './LoadPurchaseOrderDialog.form';
import { useLoadPurchaseOrder, useRetrieveProductReceiptSummary } from 'api/productReceipts/productReceipts';
import { usePRContextSelector } from '../ProductReceipts.context';

const LoadPurchaseOrderDialog = (props: ILoadPurchaseOrderDialogProps): JSX.Element => {
  const { open, onClose, linesRef, initialValues, valuesSchema } = props;
  const ProductReceiptId = usePRContextSelector<'ProductReceipt'>((state) => state.ProductReceipt);
  const ProductReceiptContext = usePRContextSelector<'ProductReceiptContext'>((state) => state.ProductReceiptContext);

  const fetchPRSummary = useRetrieveProductReceiptSummary(ProductReceiptId);

  const { mutateAsync: loadPurchaseOrderMutateAsync, isLoading: isProcessing } = useLoadPurchaseOrder();

  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = React.useState(null);

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        disabled: isProcessing,
        isDefault: true,
        listener: async () => {
          if (selectedPurchaseOrder) {
            const response = await loadPurchaseOrderMutateAsync({ ProductReceiptId, PurchaseOrder: selectedPurchaseOrder });
            if (response?.Status) {
              linesRef.current?.refreshDataGrid();
              fetchPRSummary?.refetch();
              onClose();
            }
          }

        }
      },
      {
        title: 'Cancel',
        listener: () => {
          onClose();
        }
      }
    ];
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title='Load Purchase Order'
    formProps={{
      style: {
        height: '395px',
        minWidth: '450px'
      },
      supplierId: Number(ProductReceiptContext?.SupplierId),
      warehouse: ProductReceiptContext?.Warehouse,
      formSchema: LoadPurchaseOrderForm,
      initialValues: initialValues || {},
      valuesSchema: valuesSchema,
      fieldExtensions: ({
        LoadFromPurchaseOrder: {
          onSelectedItemChange: async (value) => {
            setSelectedPurchaseOrder(value?.Code);
          }
        }
      })
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}

  />);
};

export default LoadPurchaseOrderDialog;
